export function translatePartialTranspose(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  let f = (tech === 'partial_transpose_column_to_row' ? 'column' : 'row');
  let t = (tech === 'partial_transpose_column_to_row' ? 'row' : 'column');
  let to_move = source.layout?.[f]?.[mapping[args[0]]["layout." + f]];
  if (to_move.constructor.name === "Object") to_move = to_move.field;
  else if (to_move.constructor.name === "Array") to_move = to_move[0].field || to_move[0];
  let reference = parseInt(mapping[args[2]]["layout." + t]);
  let direction = args[1]
  if (to_move !== undefined && reference !== undefined) {
    rules.push({
      category: "recommender",
      description: `Partially transpose`,
      specifier: { role: "view" },
      action: "replace",
      option: {
        from: {
          role: f,
          field: to_move,
        },
        to: {
          role: t,
          index: (direction === "before" ? reference : reference + 1)
        }
      }
    });
  }
  return rules;
}